
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(page = 1) {
        return axios.get(`${API_URL}/production-orders`, { params: { page }, headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/production-orders/${id}`, { headers: authHeader() });
    },
    send(remissionIds) {
        return axios.post(`${API_URL}/production-orders/send`, { remission_ids: remissionIds }, { headers: authHeader() });
    },
    updateStatus(id, status) {
        return axios.put(`${API_URL}/production-orders/${id}/status`, { status }, { headers: authHeader() });
    },
    createAssignment(orderId, data) {
        return axios.post(`${API_URL}/production-orders/${orderId}/assignments`, data, { headers: authHeader() });
    },
    updateAssignment(assignmentId, data) {
        return axios.put(`${API_URL}/production-order-assignments/${assignmentId}`, data, { headers: authHeader() });
    },
    completeAssignment(assignmentId, data) {
        return axios.put(`${API_URL}/production-order-assignments/${assignmentId}/complete`, data, { headers: authHeader() });
    },
    deleteAssignment(assignmentId) {
        return axios.delete(`${API_URL}/production-order-assignments/${assignmentId}`, { headers: authHeader() });
    },
    getPendingItemsGrouped(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/production-orders/export-pending-items-grouped${query}`, { headers: authHeader(), responseType: 'blob' });
    },
};
